// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__GU0OF","title":"styles_title__1bTsQ","wrapper":"styles_wrapper__RFXAU","answer":"styles_answer__1VklW"};